import React, {useState, useEffect} from 'react';
import {Store} from '../../models/store.model';
import {Http} from '../../../../Data/config/Http';
import {API_ROUTES} from '../../../../constants/apiRoutes';

interface SimpleUser {
  id: number;
  fullName: string;
  username: string;
}

interface StoreBasicFieldsProps {
  formData: Partial<Store>;
  onInputChange: (field: keyof Store, value: string) => void;
  onDeveloperChange: (developerId: number | null) => void;
}

export const StoreBasicFields: React.FC<StoreBasicFieldsProps> = ({
  formData,
  onInputChange,
  onDeveloperChange
}) => {
  const [users, setUsers] = useState<SimpleUser[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  useEffect(() => {
    setLoadingUsers(true);
    Http.get<any>(API_ROUTES.USERS.BASE, {params: {limit: 'all', status: 'active'}})
      .then(res => {
        const raw = res.data?.data;
        const items: any[] = Array.isArray(raw) ? raw : (raw?.users ?? []);
        setUsers(items.map(u => ({
          id: u.id,
          fullName: u.full_name || u.fullName || u.username,
          username: u.username,
        })));
      })
      .catch(() => {})
      .finally(() => setLoadingUsers(false));
  }, []);

  return (
    <>
      {/* Store Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          اسم المتجر
        </label>
        <input
          type="text"
          value={formData.name || ''}
          onChange={(e) => onInputChange('name', e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-brand-500"
          placeholder="أدخل اسم المتجر"
          required
        />
      </div>

      {/* Address */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          العنوان
        </label>
        <input
          type="text"
          value={formData.address || ''}
          onChange={(e) => onInputChange('address', e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-brand-500"
          placeholder="أدخل عنوان المتجر"
        />
      </div>

      {/* Manager Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          اسم المدير
        </label>
        <input
          type="text"
          value={formData.managerName || ''}
          onChange={(e) => onInputChange('managerName', e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-brand-500"
          placeholder="أدخل اسم المدير"
        />
      </div>

      {/* Developer — user select */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          المطور المسؤول
        </label>
        <select
          value={formData.developerId ?? ''}
          onChange={(e) => {
            const val = e.target.value;
            onDeveloperChange(val ? Number(val) : null);
          }}
          disabled={loadingUsers}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-brand-500 bg-white disabled:opacity-60"
        >
          <option value="">
            {loadingUsers ? 'جاري التحميل...' : '-- اختر المطور --'}
          </option>
          {users.map(u => (
            <option key={u.id} value={u.id}>
              {u.fullName}
            </option>
          ))}
        </select>
        {formData.developerName && formData.developerName !== 'غير محدد' && !formData.developerId && (
          <p className="mt-1 text-xs text-gray-500">الحالي: {formData.developerName}</p>
        )}
      </div>
    </>
  );
};
